<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.9963 6.15217H20.9393H20.6821H19.1651L18.7537 5.14784C18.4708 4.45436 17.7509 4 16.9538 4H13.3026C12.5055 4 11.7855 4.45436 11.5027 5.14784L11.0912 6.15217H9.3428H9.08567H7.02864C6.46296 6.15217 6.00013 6.63042 6.00013 7.15651V25.0435C6.00013 25.5696 6.46296 26 7.02864 26H22.9706C23.5363 26 23.9991 25.5696 23.9991 25.0435V7.15651C24.0248 6.63042 23.562 6.15217 22.9963 6.15217ZM11.8369 8.06522C12.274 8.06522 12.6598 7.82609 12.814 7.46739L13.4311 5.91304H16.8766L17.4937 7.46739C17.648 7.85 18.0337 8.06522 18.4708 8.06522H19.2936L18.548 9.42825C18.4194 9.61955 18.188 9.73913 17.9309 9.73913H12.3512C12.1198 9.73913 11.8884 9.64349 11.7598 9.45219L10.9113 8.06522H11.8369ZM21.9678 24.087H8.08286V8.06522H8.51997L9.95991 10.4565C9.95991 10.4804 9.98562 10.4565 9.98562 10.4805C10.4999 11.2218 11.3741 11.6522 12.3255 11.6522H17.9051C18.8822 11.6522 19.8079 11.1978 20.2965 10.3848C20.2965 10.3609 20.3222 10.337 20.3222 10.337L21.5564 8.06522H21.9421V24.087H21.9678Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: "allJournalIcon",
    props: {
      fill: {
        type: String,
        default: '#109CF1'
      }
    }
  }
</script>

<style scoped>

</style>
